<template>
  <PastaBaseError title="Lien invalide" :hat="message" subtitle="Erreur 400"> </PastaBaseError>
</template>

<script setup lang="ts">
import { PastaBaseError } from "@pasta/box-v2";

const message = `Le lien auquel vous essayez d'accéder est incorrect ou expiré.
L'équipe Parapheur`;
</script>
